import { render } from "./UpdateClientProfile.vue?vue&type=template&id=77f10958"
import script from "./UpdateClientProfile.vue?vue&type=script&lang=js"
export * from "./UpdateClientProfile.vue?vue&type=script&lang=js"

import "./UpdateClientProfile.vue?vue&type=style&index=0&id=77f10958&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__